import React from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { Icon, Typography } from '@ui';
import { Card, Form } from 'antd';
import { observer } from 'mobx-react';
import { isApiTokenValid } from '../../utils/apiTokenState';
import { FIELD_NAMES } from '../constants';
import SectionHeader from '../SectionHeader';
import KlicklyTab from './components/KlicklyTab';
import { StyledPanel } from './styled';

const PANEL_TITLE_STYLE = { fontWeight: 500 };

/**
 * Triple Whale card: toggle plus the Klickly invite flow, or a confirmation once a valid API token is set.
 * @param {object} props
 * @param {object} [props.style]
 * @param {object} props.tripleWhaleSettings Current account TW settings from the store.
 */
const TWSettings = observer(({ style, tripleWhaleSettings }) => {
    const form = Form.useFormInstance();
    const isEnabled = Form.useWatch(FIELD_NAMES.TRIPLE_WHALE, form);

    return (
        <Card data-e2e='tracking_enable-tw_section' style={style}>
            <SectionHeader
                icon={<Icon.TripleWhaleLogo />}
                title='Enable TripleWhale'
                fieldName={FIELD_NAMES.TRIPLE_WHALE}
                titleE2e='tracking_enable-tw_title'
                toggleE2e='tracking_enable-tw_toggle'
            />
            {isEnabled && (
                <React.Fragment>
                    <Typography.Text
                        data-e2e='tracking_enable-tw_description'
                        type='body2'
                        color={COLORS.$gray60Black}
                        style={BOTTOM_INDENTS.M}
                    >
                        Like Meta, Google, and other marketing platforms, Klickly shares impression-level data with
                        Triple Whale to provide a full view of Klickly’s touchpoints throughout the consumer journey.
                    </Typography.Text>
                    <StyledPanel>
                        {isApiTokenValid(tripleWhaleSettings) ? (
                            <Typography.Text
                                data-e2e='tracking_tw_token_set'
                                type='descriptor1'
                                color={COLORS.$gray100Black}
                                style={PANEL_TITLE_STYLE}
                            >
                                Your TW API token is set and Klickly sends “Spend” data directly to your TW account
                            </Typography.Text>
                        ) : (
                            <React.Fragment>
                                <Typography.Text
                                    type='descriptor1'
                                    color={COLORS.$gray100Black}
                                    style={{ ...BOTTOM_INDENTS.M, ...PANEL_TITLE_STYLE }}
                                >
                                    Share your TW API token with Klickly to enable us to send “Spend” data directly to
                                    your TW account
                                </Typography.Text>
                                <KlicklyTab tripleWhaleSettings={tripleWhaleSettings} />
                            </React.Fragment>
                        )}
                    </StyledPanel>
                </React.Fragment>
            )}
        </Card>
    );
});

export default TWSettings;
